import { useRef, useEffect } from 'react';

const touchErrorValue = 10; // 滑动允许误差值

// 向上滑动的回调
const useListenSlideUp = (
  ele: HTMLDivElement | null,
  cb: () => void,
  options?: { excludeELe?: HTMLElement | null }
) => {
  const startY = useRef(0);
  const endY = useRef(0);
  const isDragging = useRef(false);
  const validateContainFn = (e: TouchEvent) => {
    // console.log(ele, ele?.contains(e.target as Node), options?.excludeELe?.contains(e.target as Node))
    if (!ele) return false;
    if (options?.excludeELe) {
      return (
        ele.contains(e.target as Node) &&
        !options?.excludeELe.contains(e.target as Node)
      );
    }
    return ele.contains(e.target as Node);
  };
  useEffect(() => {
    if (!ele) return;
    const handleTouchStart = (e: TouchEvent) => {
      // 当有第二根手指同时触摸时，不处理逻辑
      if (e.touches.length > 1 || !validateContainFn(e)) {
        return;
      }
      const target = e.targetTouches[0];
      startY.current = target.clientY;
      // console.log('handleTouchStart', startY.current);
    };

    const handleTouchMove = (e: TouchEvent) => {
      if (!validateContainFn(e)) {
        return;
      }
      isDragging.current = true;
      const target = e.targetTouches[0];
      endY.current = target.clientY;
      // console.log('handleTouchMove', endY.current);
    };

    const handleTouchEnd = () => {
      if (!isDragging.current) return;
      // console.log('handleTouchEnd', endY.current - startY.current);
      // 允许滑动误差为10
      if (endY.current && endY.current < startY.current - touchErrorValue) {
        // 向上滑动的回调函数
        isDragging.current = false;
        cb();
      }
    };

    document.addEventListener('touchstart', handleTouchStart);
    document.addEventListener('touchmove', handleTouchMove);
    document.addEventListener('touchend', handleTouchEnd);

    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [ele]);
};

export default useListenSlideUp;
